var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistoryHeader = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    clipPath: "url(#clip0_0_13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8788 3C17.8977 3 21.9697 7.03125 21.9697 12C21.9697 16.9688 17.8977 21 12.8788 21C9.79167 21 7.05966 19.4766 5.41667 17.1422C4.93845 16.4625 3.99148 16.2984 3.30492 16.7719C2.61837 17.2453 2.45265 18.1828 2.93087 18.8625C5.11837 21.9656 8.75947 24 12.8788 24C19.5739 24 25 18.6281 25 12C25 5.37188 19.5739 0 12.8788 0C8.82102 0 5.23201 1.97344 3.0303 5.00156V3.75C3.0303 2.92031 2.35322 2.25 1.51515 2.25C0.677083 2.25 0 2.92031 0 3.75V9C0 9.82969 0.677083 10.5 1.51515 10.5H2.67992C2.7036 10.5 2.72727 10.5 2.75095 10.5H6.82292C7.66098 10.5 8.33807 9.82969 8.33807 9C8.33807 8.17031 7.66098 7.5 6.82292 7.5H5.00947C6.5767 4.80937 9.51705 3 12.8788 3ZM14.0152 7.125C14.0152 6.50156 13.5085 6 12.8788 6C12.2491 6 11.7424 6.50156 11.7424 7.125V12C11.7424 12.3 11.8608 12.5859 12.0739 12.7969L15.483 16.1719C15.928 16.6125 16.6477 16.6125 17.0881 16.1719C17.5284 15.7312 17.5331 15.0188 17.0881 14.5828L14.0104 11.5359V7.125H14.0152Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistoryHeader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/history-header.940967eb49b84f3a57d8bcf92a2ddb5d.svg";